export const navItems = [
  {
    name: "مارول لایف",
    href: "/",
  },
  {
    name: "ساچمه نقره",
    href: "/silvershot",
  },
  {
    name: "کتاب",
    href: "/book",
  },
  {
    name: "طلا و جواهر",
    href: "/gold-jewel",
  },
  {
    name: "تجهیزات خودرو",
    href: "/car-equipment",
  },
  {
    name: "تجهیزات دندان‌پزشکی",
    href: "/dental",
  },
  {
    name: "پوشاک",
    href: "/clothing",
  },
  {
    name: "محصولات پوستی",
    href: "/skincare",
  },
  {
    name: "تست آزمایشگاه",
    href: "/silvershot#lab-test",
  },
  // {
  //   name: "وبلاگ",
  //   href: "/blog",
  // },
];
